export default (data = {}) => {
    return {
        celular: null,
        ciudad: null,
        ciudad_cod: null,
        codigo: null,
        // compania: null,
        contacto: null,
        direccion: null,
        email: null,
        fax: null,
        id_nit: null,
        nombre: null,
        observaciones: null,
        otro: null,
        pais: null,
        regimen: null,
        store: null,
        telefono: null,
        ...data
    }
}